/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-has-content */
import { ButtonV2 } from "@Modules/common/ButtonV2";
import { Image } from "repoV2/components/common/Image";
import { CurvedArrowSvg, MEDIA, SECTION_IDS } from "@Utils";
import { classNames } from "repoV2/utils/common/render/classNames";
import React from "react";
import { ITemplate } from "@Templates/ITemplate";
import commonStyles from "../../root/yoga.module.scss";
import styles from "../AboutSection/aboutSection.module.scss";

// TODO - @aditya: use it in AboutSection in phase2
const AboutCover = ({
    coverImg,
    title,
    shortDescription,
    getInTouchCtaText,
    onGetInTouchClick,
    hideGetInTouch,
}: ITemplate.IAboutSectionProps) => {
    return (
        <div className={styles.container}>
            <a id={SECTION_IDS.about} className={commonStyles.sectionAnchor} />
            <div className={styles.bannerContainer}>
                <Image
                    alt="background"
                    src={coverImg || MEDIA.DEFAULT.BACKGROUND.YOGA}
                    className={styles.coverImage}
                />
                <div
                    className={classNames(
                        styles.bannerTextContainer,
                        commonStyles.uniformWidth
                    )}
                >
                    {title ? (
                        <h1
                            className={classNames(
                                commonStyles.sectionTitle,
                                styles.title
                            )}
                        >
                            {title}
                        </h1>
                    ) : null}
                    {shortDescription ? (
                        <div
                            className={classNames(
                                styles.shortDescription,
                                styles.desktopOnly
                            )}
                        >
                            {shortDescription}
                        </div>
                    ) : null}
                    {hideGetInTouch ? null : (
                        <div className={styles.getInTouchButtonContainer}>
                            <ButtonV2
                                applyTheme
                                onClick={() => {
                                    onGetInTouchClick();
                                }}
                                className={styles.getInTouchButton}
                            >
                                {getInTouchCtaText}
                            </ButtonV2>
                            <CurvedArrowSvg
                                className={styles.arrowIcon}
                                stroke="rgb(var(--rgbColor2-schema1-host-theme, 255, 255, 255))"
                            />
                        </div>
                    )}
                </div>
                <div className={styles.clipWhite} />
            </div>
        </div>
    );
};

export default AboutCover;
